module.exports = __webpack_public_path__ + "6b2c065c47d7a8c31dae00cfc6173e1d.png";